import React, { useEffect, useState } from 'react';
import axios from 'axios';
// Redux
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
// Network
import processRequest from 'src/services/processRequest';
import { RequestIndicatorTypes } from 'data-layer-cr/dist/models';
// models
import {
  makeYappyPaymentPayload,
  makeEvicertiaRequest,
} from 'src/models/requestTypes/creators/makeEmissionRequest';
import EvicertiaDocumentResponse from 'src/models/responseTypes/EvicertiaDocumentResponse';
// Components
import { CircularProgress } from '@material-ui/core';
import { DefaultButton } from 'design-system';
import { Download } from 'react-feather';

export const DownloadDocumentButton = ({
  state,
}: PropsFromRedux): JSX.Element => {
  const [fileBase64, updateFileBase64] = useState('');
  const [downloadCalled, updateDownloadCalled] = useState(false);
  const [fetchStatus, updateFetchStatus] =
    useState<RequestIndicatorTypes>('initial');

  useEffect(() => {
    const source = axios.CancelToken.source();

    async function fetchPdf(): Promise<void> {
      updateFetchStatus('requesting');
      const { emissionData } = makeYappyPaymentPayload(state);
      const profileId = state.quotation.quotation.quotationProfile.id;
      const evicertiaRequest = makeEvicertiaRequest(emissionData, profileId);
      try {
        const {
          data: { data },
        } = await processRequest<EvicertiaDocumentResponse>({
          method: 'POST',
          url: 'PolicyEmission/pdf/submit',
          data: evicertiaRequest,
        });
        updateFileBase64(
          `data:application/pdf;base64,${data.base64InsurancePdf}`,
        );
        updateFetchStatus('success');
      } catch (e) {
        if (!axios.isCancel(e)) {
          updateFetchStatus('failure');
        }
      }
    }

    /** If download  button is clicked and the file has not been search it will make the request
     * this ensures the request is made only 1 time
     */
    if (downloadCalled && fileBase64 === '') {
      fetchPdf();
    }
    return (): void => source.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCalled, fileBase64]);

  useEffect(() => {
    /** Once the file is loaded, it will proceed with the download action in the browser
     */
    if (downloadCalled && fileBase64 !== '') {
      updateDownloadCalled(false);
      const link = document.createElement('a');
      link.href = fileBase64;
      link.setAttribute('target', '_blank');
      link.setAttribute('download', 'insurance.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [downloadCalled, fileBase64]);

  return (
    <DefaultButton
      id="download-insurance-button"
      data-testid="download-insurance-button"
      variant="borderless"
      fullWidth
      disabled={fetchStatus === 'requesting'}
      onClick={(): void => updateDownloadCalled(true)}
    >
      {fetchStatus === 'requesting' ? (
        <CircularProgress data-testid="spinner-btn-download" />
      ) : (
        <>
          <Download data-testid="icon-btn-download" width={24} height={24} />{' '}
          &nbsp;&nbsp;Descargar solicitud
        </>
      )}
    </DefaultButton>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  state: RootState;
} => ({
  state,
});

const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DownloadDocumentButton);
